// extracted by mini-css-extract-plugin
export default {"OrdersPage":"OrdersPage_OrdersPage__xe1hb"};